import React from 'react';
import TransferDetail from 'components/Tvendo/Inventory/Operations/Kardex/Transfer';

export default function () {
  return <TransferDetail />;
}
